export default Object.freeze({
  AUTH_PENDING: 'AUTH_PENDING',
  AUTH_FULFILLED: 'AUTH_FULFILLED',
  AUTH_REJECTED: 'AUTH_REJECTED',
  AUTH_LOADED: 'AUTH_LOADED',
  AUTH_MIGRATION_PENDING: 'AUTH_MIGRATION_PENDING',
  ACCESS_TOKEN: 'ACCESS_TOKEN',
  ACCESS_TOKEN_PENDING: 'ACCESS_TOKEN_PENDING',
  ACCESS_TOKEN_FULFILLED: 'ACCESS_TOKEN_FULFILLED',
  ACCESS_TOKEN_REJECTED: 'ACCESS_TOKEN_REJECTED',
  ACCESS_TOKEN_CHECK: 'ACCESS_TOKEN_CHECK',
})
